import { jsx as a, jsxs as _ } from "react/jsx-runtime";
import { Icon as o } from "../icon/icon.js";
import "react";
import { Text as l } from "../text/text.js";
import f from "clsx";
import { c as u, d as m, e as h, f as y } from "../../virginmediao2-momentum-icons-icons-fas-CfzopcU1.js";
import '../../assets/badge.css';const w = "_badge_1ybn1_1", x = "_badge__icon_1ybn1_76", e = {
  badge: w,
  "badge--info": "_badge--info_1ybn1_24",
  "badge--error": "_badge--error_1ybn1_32",
  "badge--warning": "_badge--warning_1ybn1_39",
  "badge--success": "_badge--success_1ybn1_46",
  "badge--offer": "_badge--offer_1ybn1_53",
  "badge--outline": "_badge--outline_1ybn1_61",
  "badge--rounded": "_badge--rounded_1ybn1_72",
  badge__icon: x,
  "badge--sizer": "_badge--sizer_1ybn1_81"
}, p = (n, d) => {
  switch (n) {
    case "error":
      return /* @__PURE__ */ a(o, { icon: y, size: d, color: "inherit" });
    case "success":
      return /* @__PURE__ */ a(o, { icon: h, size: d, color: "inherit" });
    case "warning":
      return /* @__PURE__ */ a(o, { icon: m, size: d, color: "inherit" });
    default:
      return /* @__PURE__ */ a(o, { icon: u, size: d, color: "inherit" });
  }
}, j = ({
  title: n,
  outline: d,
  variant: r = "warning",
  className: i,
  showIcon: s,
  icon: b,
  iconSize: c = "md",
  rounded: g,
  ...t
}) => /* @__PURE__ */ _(
  "div",
  {
    className: f(
      {
        [e.badge]: !0,
        [e["badge--outline"]]: !!d,
        [e["badge--info"]]: r === "info",
        [e["badge--success"]]: r === "success",
        [e["badge--warning"]]: r === "warning",
        [e["badge--error"]]: r === "error",
        [e["badge--sizer"]]: !s,
        [e["badge--rounded"]]: !!g,
        [e["badge--black"]]: r === "black",
        [e["badge--offer"]]: r === "offer",
        [e["badge--countdown"]]: r === "countDown"
      },
      i
    ),
    "data-testid": "badge",
    ...t,
    children: [
      s && /* @__PURE__ */ a("div", { className: e.badge__icon, "data-testid": "badge-icon", children: b ? /* @__PURE__ */ a(o, { icon: b, size: "sm", color: "inherit" }) : p(r, c) }),
      /* @__PURE__ */ a(
        l,
        {
          className: e.badge__text,
          "data-testid": "badge-text",
          size: "T200",
          weight: "bold",
          color: "inherit",
          children: n
        }
      )
    ]
  }
);
export {
  j as Badge,
  p as getIcon
};
